import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { renderChildren, text } from "../helpers";

var root = $.from_html(`<div></div>`);

export default function Column($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	var div = root();

	$.action(div, ($$node, $$action_arg) => renderChildren?.($$node, $$action_arg), () => $$props.ctx);

	$.template_effect(
		($0, $1) => {
			$.set_class(div, 1, $0);
			$.set_attribute(div, 'id', $1);
		},
		[
			() => `slex-column${$.get(p).class ? ` ${text($.get(p).class)}` : ""}`,
			() => $.get(p).id ? text($.get(p).id) : undefined
		]
	);

	$.append($$anchor, div);
	$.pop();
}